import type { BlockType } from "../types"
import { getBlockConfig } from "../registry"
import { Card, CardContent, CardHeader } from "@/components/ui/card"

interface FallbackBlockEditorProps {
  content?: unknown
  onChange?: (content: Record<string, unknown>) => void
  block?: { section_type: string }
}

/** Shown when no dedicated editor exists for a block type (e.g. future block types). */
export function FallbackBlockEditor({ block }: FallbackBlockEditorProps) {
  const blockType = (block?.section_type ?? "unknown") as BlockType
  const config = getBlockConfig(blockType)
  return (
    <Card>
      <CardHeader>
        <h3 className="text-base font-medium">{config.label}</h3>
        <p className="text-sm text-muted-foreground">
          Block type: {blockType}. Editor coming soon.
        </p>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground">
          Use the block picker to replace this block with a supported type.
        </p>
      </CardContent>
    </Card>
  )
}
